import { BfsToken } from "../Interfaces/User";

export const getAuthHeader = (tokens: BfsToken) => ({
    Authorization: `Bearer ${tokens.access.token}`
});